import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { PipelineSettingsComponent } from './pipeline-settings.component';
import { PipelineSettingsService } from './pipeline-settings.service';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
@NgModule({
  declarations: [PipelineSettingsComponent],
  exports: [PipelineSettingsComponent],
  providers: [PipelineSettingsService],
  imports: [
    CommonModule,
    GalaxyPageModule,
    TranslateModule,
    MatButtonModule,
    GalaxyStickyFooterModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInput,
    MatIcon,
    MatCardModule,
    MatDivider,
    GalaxyLoadingSpinnerModule,
    GalaxyEmptyStateModule,
  ],
})
export class PipelineSettingsModule {}
